import React, {useRef, useState} from 'react'
import { Calendar3Week } from 'react-bootstrap-icons'
import { SingleDatePicker } from 'react-dates'
import moment from 'moment'
import LabeledInput from '../labeled-input'
import { uniqueId } from 'lodash'

const currentDate = new Date()

const SingleDatePickerFilter = ({
    value,
    onChange = () => {},
    showIcon,
    label = 'Start Date',
    placeholder,
    showClearDate,
    showPastDates = false
}) => {
    const [pickerVisible, setVisible] = useState(false)
    const { current: id } = useRef(uniqueId('prefix-'))

    const onDateChange = React.useCallback((momentDate) => {
        if(moment(momentDate).isValid()) {
            onChange(momentDate.toDate())
        }
    }, [onChange])

    const isOutsideRange = showPastDates ? () => false : undefined

    return (
        <LabeledInput
            iconComponent={showIcon ? Calendar3Week : null}
            label={label}
        >
            <div className='form-group'>
                <SingleDatePicker
                    id={id}
                    placeholder={placeholder}
                    date={value ? moment(value) : undefined}
                    onDateChange={date => onDateChange(date)}
                    focused={pickerVisible}
                    onFocusChange={({ focused }) => setVisible(focused)}
                    numberOfMonths={1}
                    hideKeyboardShortcutsPanel
                    regular
                    showClearDate={showClearDate}
                    isOutsideRange={isOutsideRange}
                />
            </div>
            
        </LabeledInput>
    )
}

export default SingleDatePickerFilter